import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleLayout from './components/ArticleLayout';
import { getArticle } from './data';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (!slug) return;
    const article = getArticle(slug);
    if (!article) return;
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.help';
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": article.title,
      "description": article.description,
      "image": article.image,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `${siteUrl}/article/${article.slug}`
      },
      "datePublished": "2026-08-11",
      "dateModified": "2026-08-18",
      "author": {
        "@type": "Organization",
        "name": "Basetao Sheet Help"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Basetao Sheet Help",
        "url": siteUrl
      }
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [slug]);

  const article = slug ? getArticle(slug) : undefined;

  if (!article) {
    return (
      <main>
        <Navbar />
        <div className="pt-24 pb-16 md:pt-28 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-background-100 flex items-center justify-center">
              <i className="ri-file-search-line text-foreground-400 text-3xl"></i>
            </div>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Article Not Found</h1>
            <p className="text-foreground-600 mb-8">The article you are looking for does not exist or may have been moved.</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              Back to Home
            </Link>
          </div>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main>
      <Navbar />
      <div className="pt-24 md:pt-28">
        <ArticleLayout article={article} />
      </div>
      <Footer />
    </main>
  );
}